import { Radio } from 'ant-design-vue'
import Storage from 'vue-ls'
import VerifyType from './App'

VerifyType.install = (Vue) => {
  Vue.use(Radio)
  Vue.use(Storage)
  Vue.component(VerifyType.name, VerifyType)
}

export default VerifyType
